<template>
  <div class="slipbox__container">
    <transition :name="transitionNames">
      <div v-show="visible" :class="clazz">
        <div v-clickout-side="onClickoutSide" :class="[prefixCls + '__content']" :style="styls">
          <div :class="[prefixCls + '__header']">
            <slot name="header">
              <div :class="headerInnerClazz">
                <t-icon :type="arrowType" :class="headerArrowClazz" @click.native="onHideSlip"></t-icon>
                <span :class="[prefixCls + '__title']">{{ title }}</span>
              </div>
            </slot>
          </div>
          <div :class="[prefixCls + '__body']">
            <slot></slot>
          </div>
        </div>
      </div>
    </transition>
    <div v-if="needBackDrop" :class="{'show': visible===true}" class="slipbox__wrap--backdrop modal-backdrop"></div>
  </div>
</template>
<script>
/**
 * 使用的是sync修饰符，vuejs 版本需要 > 2.3
 */
import Locale from '../../mixins/locale'
import Emitter from '../../mixins/emitter'
import { getScrollBarSize } from '../../utils/assist'
import TransferDom from '../../directives/transfer-dom'
import ClickoutSide from '../../directives/clickoutside'
import Icon from '../icon'
const PREFIXCLS = 'slipbox'
export default {
  name: 'TSlipbox',
  directives: {
    TransferDom,
    ClickoutSide
  },
  components: {
    Icon
  },
  mixins: [Locale, Emitter],
  props: {
    title: {
      type: String
    },
    visible: {
      type: Boolean,
      default: false
    },
    transitionName: {
      type: String
    },
    direction: {
      type: String,
      default: 'right',
      validator: value => {
        return value === 'left' ? 'left' : 'right'
      }
    },
    styles: {
      type: Object
    },
    width: {
      type: Number
    },
    height: {
      type: Number
    },
    beforeClose: Function,
    // 是否需要显示backUp
    needBackDrop: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      prefixCls: PREFIXCLS,
      showSlip: this.visible
    }
  },
  computed: {
    transitionNames() {
      if (!this.transitionName) {
        return this.direction === 'left' ? 'move-left' : 'move-right'
      } else {
        return this.transitionName
      }
    },
    clazz() {
      return [
        `${PREFIXCLS}__wraper`,
        {
          [`${PREFIXCLS}__wraper--show`]: this.showSlip
        },
        {
          [`${PREFIXCLS}__wraper--hide`]: !this.showSlip
        },
        {
          [`${PREFIXCLS}__wraper--right`]: this.direction === 'right'
        },
        {
          [`${PREFIXCLS}__wraper--left`]: this.direction !== 'right'
        },
        {
          [`${PREFIXCLS}__wraper--hasBack`]: this.needBackDrop
        }
      ]
    },
    headerInnerClazz() {
      return [
        `${PREFIXCLS}__header--inner`,
        {
          [`${PREFIXCLS}__header--border`]: this.title // '#979797'
        }
      ]
    },
    headerArrowClazz() {
      return [
        `${PREFIXCLS}__arrow`,
        {
          [`${PREFIXCLS}__arrow--left`]: this.direction === 'left'
        }
      ]
    },
    arrowType() {
      return this.direction === 'left' ? 'arrow-left' : 'arrow-right'
    },
    styls() {
      let sty = {}
      const WIDTH = 'width'
      const HEIGHT = 'height'
      if (this.width) {
        sty[WIDTH] = this.width + 'px'
      }
      if (this.height) {
        sty[HEIGHT] = this.height + 'px'
      }
      if (this.needBackDrop) {
        sty['zIndex'] = 1051
      }
      return Object.assign(this.styles || {}, sty)
    }
  },
  watch: {
    visible(val) {
      this.showSlip = val
      if (val) {
        let width = this.$el.style.width || this.$el.offsetWidth || '350px'
        this.$emit('on-slip-show', width.toString().replace(/px/g, ''))
        // this.$el.style.overflow = 'auto'
        this.addScrollEffect()
        // if (this.needBackDrop) {
        //   let backdrop = document.createElement('div')
        //   backdrop.className = 'slipbox__wrap--backdrop modal-backdrop show'
        //   setTimeout(() => {
        //     this.$el.querySelector('.slipbox__wraper').appendChild(backdrop)
        //   }, 500)
        // }
      } else {
        this.removeScrollEffect()
        this.$emit('on-slip-hide', 0)
        // if (this.needBackDrop) {
        //   let backdrop = document.querySelector('.slipbox__wrap--backdrop')
        //   this.$el.querySelector('.slipbox__wraper').removeChild(backdrop)
        // }
      }
    },
    showSlip(value) {
      this.$emit('update', this.showSlip)
    }
  },
  methods: {
    onHideSlip() {
      if (typeof this.beforeClose === 'function') {
        this.beforeClose(this.hide)
      } else {
        this.hide()
      }
    },
    hide() {
      this.showSlip = false
      this.$emit('update:visible', this.showSlip)
      this.removeScrollEffect()
    },
    // control if has scrollbar
    checkScrollBar() {
      let fullWindowWidth = window.innerWidth
      if (!fullWindowWidth) {
        // workaround for missing window.innerWidth in IE8
        const documentElementRect = document.documentElement.getBoundingClientRect()
        fullWindowWidth =
          documentElementRect.right - Math.abs(documentElementRect.left)
      }
      this.bodyIsOverflowing = document.body.clientWidth < fullWindowWidth
      if (this.bodyIsOverflowing) {
        this.scrollBarWidth = getScrollBarSize()
      }
    },
    setScrollBar() {
      if (this.bodyIsOverflowing && this.scrollBarWidth !== undefined) {
        document.body.style.paddingRight = `${this.scrollBarWidth}px`
      }
    },
    $_isChildNode(child, parent) {
      while (
        child !== undefined &&
        child !== null &&
        child.tagName &&
        child.tagName.toUpperCase() !== 'BODY'
      ) {
        if (child === this.$el.getElementsByClassName(parent)[0]) {
          return true
        }
        child = child.parentNode
      }
      return false
    },
    $_ischild(child) {
      while (
        child !== undefined &&
        child !== null &&
        child.tagName &&
        child.tagName.toUpperCase() !== 'BODY'
      ) {
        if (child === this.$el) {
          return true
        }
        child = child.parentNode
      }
      return false
    },
    $_isNotDropDown(child) {
      while (
        child !== undefined &&
        child !== null &&
        child.tagName &&
        child.tagName.toUpperCase() !== 'BODY'
      ) {
        if (child.classList.contains('dropdown__menu')) {
          return true
        }
        child = child.parentNode
      }
      return false
    },
    onClickoutSide(evt) {
      let val = false
      // if (evt.target.classList.contains('slipbox__wrap--backdrop') || evt.target.tagName === 'body' || (!this.$$_ischildNode(evt.target) && !this.$_isNotDropDown(evt.target))) {
      if (
        evt.target.classList.contains('slipbox__wrap--backdrop') ||
        evt.target.tagName === 'body'
      ) {
        this.onHideSlip()
        val = true
      } else if (
        this.$_ischild(evt.target) &&
        (!evt.target.classList.contains('slipbox__content') ||
          !this.$_isChildNode(evt.target, 'slipbox__content'))
      ) {
        this.onHideSlip()
        val = true
      }
      return val
    },
    resetScrollBar() {
      document.body.style.paddingRight = ''
    },
    addScrollEffect() {
      this.checkScrollBar()
      this.setScrollBar()
      document.body.style.overflow = 'hidden'
    },
    removeScrollEffect() {
      document.body.style.overflow = ''
      this.resetScrollBar()
    }
  }
}
</script>



// WEBPACK FOOTER //
// slipbox.vue?1f8b7c27